import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import CapacitorConsumer from './CapacitorConsumer';

const withCapacitor = (WrappedComponent) => {
  const HOC = class extends Component {
    render() {
      const { forwardedRef, ...restProps } = this.props;
      return (
        <CapacitorConsumer>
          {(context) => (
            <WrappedComponent {...restProps} capacitorContext={context} ref={forwardedRef} />
          )}
        </CapacitorConsumer>
      );
    }
  };

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
};

export { withCapacitor };
